<template>
  <div class="accordion-item">
    <div class="accordion-header">
      <button
        class="accordion-button collapsed"
        type="button"
        data-bs-toggle="collapse"
        :data-bs-target="`${accordionSelector} ${itemSelector}`"
      >
        <slot name="heading"></slot>
      </button>
    </div>
    <div 
      class="accordion-collapse collapse"
      :data-bs-parent="accordionSelector"
      :data-item-id="props.itemId"
    >
      <div class="accordion-body">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps(['accordionId', 'itemId'])
const accordionSelector = `.accordion[data-accordion-id='${props.accordionId}']`;
const itemSelector = `.accordion-collapse[data-item-id='${props.itemId}']`;
</script>
